var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCirclepackingPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#ADB5BD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.999,
    cy: 66.9961,
    r: 34,
    fill: "#98A1AA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.999,
    cy: 143.996,
    r: 46,
    fill: "#98A1AA"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.499,
    cy: 94.4961,
    r: 33.5,
    fill: "#98A1AA"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.999,
    cy: 39.9961,
    r: 28,
    fill: "#98A1AA"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.4415,
    cy: 168.588,
    r: 14.9482,
    transform: "rotate(-105 80.4415 168.588)",
    fill: "#373D43"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.158,
    cy: 144.963,
    r: 20.224,
    transform: "rotate(-105 109.158 144.963)",
    fill: "#373D43"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.3427,
    cy: 121.506,
    r: 14.7283,
    transform: "rotate(-105 80.3427 121.506)",
    fill: "#373D43"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.0342,
    cy: 145.755,
    r: 12.3102,
    transform: "rotate(-105 62.0342 145.755)",
    fill: "#373D43"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.48,
    cy: 48.6567,
    r: 11.395,
    transform: "rotate(30 47.48 48.6567)",
    fill: "#373D43"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.7352,
    cy: 76.8708,
    r: 15.4168,
    transform: "rotate(30 44.7352 76.8708)",
    fill: "#373D43"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.9118,
    cy: 73.982,
    r: 11.2275,
    transform: "rotate(30 72.9118 73.982)",
    fill: "#373D43"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.7097,
    cy: 51.0426,
    r: 9.38416,
    transform: "rotate(30 69.7097 51.0426)",
    fill: "#373D43"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.77,
    cy: 103.776,
    r: 13.0101,
    transform: "rotate(30 148.77 103.776)",
    fill: "#373D43"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 172.142,
    cy: 102.142,
    r: 8.88847,
    transform: "rotate(30 172.142 102.142)",
    fill: "#373D43"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 163.149,
    cy: 79.15,
    r: 13.2863,
    transform: "rotate(30 163.149 79.15)",
    fill: "#373D43"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.865,
    cy: 46.4041,
    r: 8.40451,
    transform: "rotate(-180 127.865 46.4041)",
    fill: "#373D43"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.214,
    cy: 27.3709,
    r: 11.3708,
    transform: "rotate(-180 119.214 27.3709)",
    fill: "#373D43"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.281,
    cy: 39.6063,
    r: 8.28091,
    transform: "rotate(-180 102.281 39.6063)",
    fill: "#373D43"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.786,
    cy: 53.0786,
    r: 6.92136,
    transform: "rotate(-180 112.786 53.0786)",
    fill: "#373D43"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.5,
    cy: 53.5,
    rx: 4.5,
    ry: 4.5,
    transform: "rotate(-180 99.5 53.5)",
    fill: "#373D43"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.5,
    cy: 34.5,
    rx: 4.5,
    ry: 4.5,
    transform: "rotate(-180 135.5 34.5)",
    fill: "#373D43"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.5,
    cy: 89.5,
    rx: 4.5,
    ry: 4.5,
    transform: "rotate(-180 66.5 89.5)",
    fill: "#373D43"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.5,
    cy: 170.5,
    rx: 4.5,
    ry: 4.5,
    transform: "rotate(-180 102.5 170.5)",
    fill: "#373D43"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.5,
    cy: 118.5,
    rx: 4.5,
    ry: 4.5,
    transform: "rotate(-180 102.5 118.5)",
    fill: "#373D43"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 144.5,
    cy: 85.5,
    rx: 4.5,
    ry: 4.5,
    transform: "rotate(-180 144.5 85.5)",
    fill: "#373D43"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5,
    cy: 58.5,
    rx: 4.5,
    ry: 4.5,
    transform: "rotate(-180 31.5 58.5)",
    fill: "#373D43"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclepackingPreview);
export default __webpack_public_path__ + "static/media/circlepackingPreview.a44afbb8489509c99fb65420cbc8b761.svg";
export { ForwardRef as ReactComponent };